
<template>
  <div class="user-manager" @keyup.enter="enterSearch">
    <el-form class="table-search-bar maintain-form" inline ref="form" :model="form" label-width="70px">
      <el-form-item label="状态" prop="status">
        <el-select v-model="form.status" placeholder="请选择">
          <el-option
            v-for="item in statusArr"
            :key="item.id"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="类型" prop="type">
        <el-select v-model="form.type" placeholder="请选择">
          <el-option
            v-for="item in typeArr"
            :key="item.id"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="被叫号码" prop="sendTarget">
        <el-input v-model="form.sendTarget" placeholder="请输入用户手机"></el-input>
      </el-form-item>
      <el-form-item label="通知时间" prop="createTime">
        <el-date-picker
          popper-class="picktime-box"
          v-model="form.time"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          :defaultTime="['00:00:00', '23:59:59']"
          :clearable="false">
        </el-date-picker>
    </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="data"
      tooltip-effect="light"
      ref="multipleTable"
      style="width: 100%">
      <el-table-column
        prop="messageMatterId"
        label="外呼模板编号"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        label="消息类型"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">{{ handleType(scope.row.templateCode) }}</template>
      </el-table-column>
      <el-table-column
        prop="messageSubject"
        label="消息主题"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="sendTarget"
        label="被叫号码"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        label="通知内容"
        prop="content"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="sendTime"
        label="通知时间"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">{{ scope.row.status === 1 ? '成功' : '失败' }}</template>
      </el-table-column>
      <el-table-column
        prop="failResult"
        label="失败原因"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        label="建议"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">{{ handleSuggestion(scope.row.failResult) }}</template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      :current-page="listState.pageNo"
      background>
    </el-pagination>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { formatTime } from '../../../common/utils'
export default {
  name: 'callLogManager',
  data () {
    return {
      suggestions: [],
      typeArr: [
        { value: '', label: '全部' },
        { value: 'SMS', label: '短信' },
        { value: 'TTS', label: '语音' }],
      statusArr: [
        { value: '', label: '全部' },
        { value: 1, label: '成功' },
        { value: 0, label: '失败' }],
      form: {
        sendTarget: '',
        time: [formatTime(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 7), true), formatTime(new Date(), true)],
        status: '',
        type: ''
      }
    }
  },
  computed: {
    ...mapState({
      data: state => state.callLogManager.list,
      listState: state => state.callLogManager.listState
    })
  },
  methods: {
    ...mapActions(['getCallLogList', 'queryDictListInfo']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    // 搜索
    handleSearch () {
      const params = {
        ...this.form,
        pageNo: 1
      }
      console.log(this.form)
      this.getCallLogList(params)
    },
    // 重置
    handleReset () {
      this.$refs['form'].resetFields()
      this.form.time = [formatTime(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 7), true), formatTime(new Date(), true)]
      this.handleSearch()
    },
    handleSizeChange (val) {
      this.getCallLogList({ pageNo: 1, pageSize: val })
    },
    handleCurrentChange (val) {
      this.getCallLogList({ pageNo: val })
    },
    handleType (val) {
      if (val.includes('SMS')) {
        return '短信'
      } else if (val.includes('TTS')) {
        return '语音'
      }
      return '-'
    },
    handleSuggestion (val) {
      if (val) {
        let sugg = this.suggestions.find(item => item.name === val)
        if (sugg) {
          return sugg.description
        } else {
          return ''
        }
      }
      return ''
    }
  },
  mounted () {
    // 查询SAP客户业务订单字典
    this.queryDictListInfo({ code: 'call_suggestion' }).then(res => {
      this.suggestions = res.data
      console.log(this.suggestions)
    })
    this.handleSearch()
  }
}
</script>

<style lang="scss" scoped>
.line {
  margin-top: 15px;
}
</style>
